/**
 * Derive compact project health from real list_project fields only.
 * Never invent metrics — returns null when insufficient data.
 */
export function deriveProjectHealth(project) {
  const cases = Number(project?.testCases ?? project?.originalData?.test_case_count ?? 0);
  const passRateRaw = project?.passRate ?? project?.originalData?.pass_rate;
  const passRate =
    passRateRaw == null || passRateRaw === '' ? null : Number(passRateRaw);

  if (!cases || cases <= 0) {
    return { key: 'nodata', label: 'No Data', tone: 'neutral' };
  }
  if (passRate == null || Number.isNaN(passRate)) {
    return { key: 'nodata', label: 'No Data', tone: 'neutral' };
  }
  if (passRate >= 90) {
    return { key: 'healthy', label: 'Healthy', tone: 'success' };
  }
  if (passRate >= 75) {
    return { key: 'attention', label: 'Needs Attention', tone: 'warning' };
  }
  return { key: 'critical', label: 'Critical', tone: 'danger' };
}

/**
 * Format pass rate for display.
 * Hide when the project has no test cases — a rate with 0 cases is meaningless
 * (and list_project sometimes echoes a workspace-level average onto every row).
 */
export function formatPassRate(project) {
  const cases = Number(project?.testCases ?? project?.originalData?.test_case_count ?? 0);
  if (!cases || cases <= 0) return null;

  const passRateRaw = project?.passRate ?? project?.originalData?.pass_rate;
  if (passRateRaw == null || passRateRaw === '') return null;
  const n = Number(passRateRaw);
  if (Number.isNaN(n)) return null;
  return `${n % 1 === 0 ? n : n.toFixed(1)}%`;
}

/**
 * True when the project has a Bitbucket/Git repository linked for storing
 * automation scripts (is_repo_linked / repository fields from list_project).
 */
export function hasRepositoryLinked(project) {
  const raw = project?.originalData || project || {};
  return Boolean(
    raw.is_repo_linked ||
      raw.repo_linked ||
      raw.repository_url ||
      raw.git_repo ||
      raw.repo_name ||
      (raw.repository && (raw.repository.url || raw.repository.name))
  );
}
